// Reglas de negocio AvanzaEsp para el formulario de eventos, extraídas a un
// módulo puro para poder testear el contrato sin montar FormEvento (legacy).
//
// Contrato:
// - evo_enabled activo y evento NO experiencia => vincular partido es obligatorio.
// - Editar (eventoId presente) => obligatorio evo_match_id.
// - Crear => obligatorio evo_match_id O create_in_evo.
// - Experiencia => nada obligatorio.
export function validateEvoRequirement({ evoEnabled, experiencia, eventoId, evoMatchId, createInEvo }) {
    const required = !!evoEnabled && !experiencia;

    if (!required) {
        return { required: false, valid: true };
    }

    const valid = eventoId
        ? !!evoMatchId
        : (!!evoMatchId || !!createInEvo);

    return { required: true, valid };
}

// Normaliza el payload antes de emitirlo:
// - Si hay evo_match_id, create_in_evo pasa a false (exclusividad: se vincula
//   el partido seleccionado, no se crea uno nuevo).
// - Si es experiencia, ambos campos se limpian.
// NO muta el payload original.
export function normalizeEvoPayload(payload) {
    const normalized = { ...payload };

    if (normalized.evo_match_id) {
        normalized.create_in_evo = false;
    }

    if (normalized.experiencia) {
        normalized.evo_match_id = null;
        normalized.create_in_evo = false;
    }

    return normalized;
}
